import React, { useState, useEffect, useContext, useMemo } from 'react';
import SimpleTable from '../../../components/tables/simpleTable';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import ViewSession from './viewSession';
import SearchFilter from '../../../components/filters/search';
import DatePicker from '../../../components/filters/datePicker';
import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';
import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { FcViewDetails, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { DataContext } from '../../../init/getData';

function Session(props) {
  const { api, userData, settingData, allUserData } = useContext(DataContext);
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  const table = 'session';
  const title = 'Sessions';

  const today = new Date().toISOString().split('T')[0];
  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ 
    search: '', 
    fromDate: today, 
    toDate: today, 
    createdBy: null 
  });

  const [showViewModal, setShowViewModal] = useState(false);

  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  // Prepare user options for filter
const allUserOptions = useMemo(() => {
  if (!allUserData) return [];
  return allUserData.map(user => ({
    value: user.id,
    label: user.name
  }));
}, [allUserData]);


  // Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => ({
      ID: item.id,
      User: item.created?.name,
      Opened: dateTableFormatter(item.openedAt),
      Closed: dateTableFormatter(item.closedAt),

    
      Status: item.isClosed ? 'Closed' : 'Open'
    }));

    return { transformedData };
  };

  const newColumnDefs = useMemo(() => [
    { title: 'ID', dataIndex: 'id', width: '10%', sorter: (a, b) => a.id - b.id },
    { title: 'User', dataIndex: 'created', width: '15%', render: (created) => (created?.name) },
    { title: 'Opened', dataIndex: 'openedAt', width: '15%', render: dateTableFormatter },
    { title: 'Closed', dataIndex: 'closedAt', width: '15%', render: dateTableFormatter },


    {   
      title: 'Status', 
      dataIndex: 'isClosed', 
      width: '8%', 
      render: (isClosed) => (
        <Tag color={isClosed ? 'green' : 'blue'}>
          {isClosed ? 'Closed' : 'Open'}
        </Tag>
      )
    },
    {
      title: 'View',
      width: '5%',
      render: (_, record) => (
        <FcViewDetails size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
      ),
    },
  ], []);

  // Handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };

  const tableFooter = (
    <div></div>
  )

  return (
   <div className='card'>

    <div> 
        
    </div>
      {isLoading && <Loader />}

      {!isLoading && ( 
        <div>
          <div>
            <Row className='g-2 mb-3 align-items-center'>

                <Col md={8}>
                    <DatePicker setFilter={setFilter} filter={filter} />
                </Col>

                <Col md={2}>
                    <Select
                    styles={selectStyles}
                    options={allUserOptions}
                    isSearchable={true}
                    isClearable={true}
                    onChange={(e) => handleSelectChange(e, 'createdBy')}
                    value={allUserOptions.find(option => option.value === filter.createdBy) || null}

                    placeholder={'Select User ... '}
                    />
                </Col>

              
                </Row>

            <SimpleTable
              filter={filter}
              table={table}
              title={title}
              columnDefs={newColumnDefs}
              idRow={idRow}
              setIdRow={setIdRow}
              refreshTable={refreshTable}
              data={data}
              setData={setData} 
              tableFooter={tableFooter}
              api={api}
              getExcelData={getExcelData}
            />

            {showViewModal && (
              <ViewSession
                showModal={showViewModal}
                toggleModal={viewModal}
                idRow={idRow}
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Session;